import io from 'socket.io-client'
import Emitter from 'event-emitter'

import TensorManager from "@/tensor/tensorManager"

const backendUrlFromHostPort = () => {
  const backendHost = process.env.VUE_APP_SHIFUMI_BACKEND_HOST
  const backendPort = process.env.VUE_APP_SHIFUMI_BACKEND_PORT
  if (!backendHost) {
    return null
  }
  const backendProtocol = process.env.VUE_APP_SHIFUMI_BACKEND_PROTOCOL || window.location.protocol.replace(':', '')
  const suffix = backendPort ? `:${backendPort}` : ''
  return `${backendProtocol}://${backendHost}${suffix}`
}

const backendUrl = process.env.VUE_APP_SHIFUMI_BACKEND_URL || backendUrlFromHostPort() || window.location.origin

class WebsocketManager {
  constructor() {
    this._emitter = {}
    Emitter(this._emitter)
    this.on = this._emitter.on.bind(this._emitter)
    this.off = this._emitter.off.bind(this._emitter)

    this.paired = false
    this.oponentName = ""
    this.gameManager = undefined
  }

  setGameManager (gameManager) {
    this.gameManager = gameManager
  }

  connect(name){
    this.name = name
    this.room
    this.socket.emit('request-room', this.name)
    this._emitter.emit('request-room', this.name)
  }

  aiConnect(){
    // this.socket.emit('request-ai-room', name)
    this.socket.emit('leave', this.room)
  }

  close(){
    if (this.tensorListener) {
      TensorManager.off("signFound", this.tensorListener)
    }
    this.socket.close()
  }

  init() {
    TensorManager.on("signFound", this.tensorListener = (sign) => { this.sendTrackingData(sign) })

    //       SOCKET.io
    //////////////////////////
    this.socket = io(backendUrl, { rejectUnauthorized: false })
    // console.log(this.socket)
    // this.socket.on('message', msg => {
    //   console.log(msg)
    // })

    // this.socket.on('user', name => {
    //   console.log(`New user ! Welcome ${name}`)
    // })

    this.socket.on('tracking', data => {
      this._emitter.emit("tracking", data)
    })

    this.socket.on('round-result', data => {
      this._emitter.emit("round-result", data)
    })

    this.socket.on('join-room', data => {
      this.room = data.room
      // console.log(`${data.user} join ${data.room}`)
      this._emitter.emit("join-room", data)
    })

    this.socket.on('already', (data) => {
      this.onReady(data)
    })

    this.socket.on('leave-room', () => {
      // console.log(`User leave the room`)
      this.socket.emit('leave', this.room)
      this._emitter.emit("leave")
      this.paired = false
    })
  }

  onReady(data){
    // console.log(`Room full, start the game !!`, data)
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== this.name) {
        this.oponentName = data[i]
      }
    }
    this._emitter.emit("roomcomplete", { username: this.oponentName })
    this.paired = true
  }

  sendTrackingData(sign) {
    if (this.gameManager && this.gameManager.inGame && !this.gameManager.ai) {
      // this.socket.emit('send-tracking', { room: this.room, tracking: sign })
    }
  }

  sendRoundResult(data) {
    if (this.gameManager && this.gameManager.inGame && !this.gameManager.ai) {
      this.socket.emit('send-round-result', { room: this.room, data: data })
    }
  }

}

const out = new WebsocketManager()
export default out
